/* eslint-disable no-param-reassign */

import BreakdownAugmenter from '../../lib/breakdown-augmenter';

export default {
  breakdownConfigSet: (state, { slug, config }) => {
    // eslint-disable-next-line prefer-object-spread
    state.configs = Object.assign({}, state.configs, { [slug]: config });
  },
  breakdownAugmented: (state, breakdownSlug) => {
    const { breakdownsAttributes, primaryGeo, secondaryGeo, configs } = state;
    const breakdownConfig = configs[breakdownSlug];
    const breakdownAttributes = breakdownsAttributes[breakdownSlug] ?? [];

    const attrMap = breakdownAttributes.reduce((acc, attr) => {
      const key = `${attr.field}:${attr.key}`;
      acc[key] = acc[key] || { field: attr.field, value: attr.key };
      acc[key][attr.type] = attr.value;
      return acc;
    }, {});
    const attrs = Object.values(attrMap);
    const modifier = new BreakdownAugmenter(breakdownConfig);
    const breakdown = modifier.get({
      attributes: attrs,
      primaryGeo,
      secondaryGeo,
    });

    // eslint-disable-next-line prefer-object-spread
    state.breakdowns = Object.assign({}, state.breakdowns, {
      [breakdownSlug]: breakdown,
    });
  },
  breakdownSelected: (state, slug) => {
    state.selectedBreakdownId = slug;
  },

  setData: (state, { slug, data }) => {
    // eslint-disable-next-line prefer-object-spread
    state.breakdownsData = Object.assign({}, state.breakdownsData, {
      [slug]: Object.freeze(data),
    });
  },

  setAttributes: (state, { slug, attributes }) => {
    // eslint-disable-next-line prefer-object-spread
    state.breakdownsAttributes = Object.assign({}, state.breakdownsAttributes, {
      [slug]: Object.freeze(attributes),
    });
  },

  setGeos: (state, { geos }) => {
    state.geos = Object.freeze(geos);
  },

  setArgs: (state, { args }) => {
    state.args = Object.freeze(args);
  },

  setPrimaryGeo: (state, { primaryGeo }) => {
    state.primaryGeo = primaryGeo;
  },

  setSecondaryGeo: (state, { secondaryGeo }) => {
    state.secondaryGeo = secondaryGeo;
  },

  setGeoType: (state, { geoType }) => {
    state.geoType = geoType;
  },

  setGeoSection: (state, { geoSection }) => {
    state.geoSection = geoSection;
  },

  setLoading: (state, { isLoading }) => {
    if (!isLoading && !state.hasLoaded) state.hasLoaded = true;
    state.isLoading = isLoading;
  },

  setIsDownloadLoading: (state, { isDownloadLoading }) => {
    state.isDownloadLoading = isDownloadLoading;
  },
  setActiveGeoType: (state, payload) => {
    state.activeGeoType = payload;
  },
};
